import React, { useEffect, useState } from "react";
import { Col, Form, ProgressBar, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { Controller, useForm } from "react-hook-form";
import DetailRow from "../CustomComponents/DetailRow";
import { GAME_TYPE, QUESTION_TYPE } from "../../constants";
import UserAvatar from "../CustomComponents/UserAvatar";

const DetailGameQuestionModal = ({ handleEditModalClose, editData }) => {
  console.log(editData);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">More Details</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row className="text-black g-5">
              <Col sm={12} md={12}>
                {editData.question.image !== null ? (
                  <img
                    alt="package"
                    src={editData.question.image}
                    loading="lazy"
                    width={62}
                    height={62}
                    className="rounded-circle object-fit-cover"
                  />
                ) : (
                  ""
                )}
                <DetailRow
                  title={"Question"}
                  value={editData.question.question}
                />
                <DetailRow
                  title={"Short Answer"}
                  value={editData.question.short_answer}
                />
                <DetailRow title={"Points"} value={editData.question.points} />
                <DetailRow
                  title={"Type"}
                  value={
                    editData.question.question_type === QUESTION_TYPE.EASY
                      ? "Easy"
                      : editData.question.question_type === QUESTION_TYPE.MEDIUM
                      ? "Medium"
                      : "Hard"
                  }
                />
                <DetailRow
                  title={"Completed"}
                  value={editData.is_completed ? "Yes" : "No"}
                />
                <DetailRow title={"Team"} value={editData.team_name} />
                {/* <DetailRow
                  title={"Time Duration"}
                  value={editData.time_duration}
                /> */}
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DetailGameQuestionModal;
